import { readCookie } from "@packages/util/cookie/cookie";

const WHITELABEL_KEY_COOKIE = "whitelabelKey";
const COOKIE_MAX_AGE = 86400 * 60;

const KEY_REGEX = /^[a-z0-9-]{1,64}$/i;

function sanitizeKey(key) {
    return key && KEY_REGEX.test(key) ? key : "";
}

export function resolveWhitelabelUrlKey() {
    try {
        return sanitizeKey(new URLSearchParams(window.location.search).get("key"));
    } catch (e) {
        return "";
    }
}

export function resolveWhitelabelKey() {
    try {
        return resolveWhitelabelUrlKey() || sanitizeKey(readCookie(WHITELABEL_KEY_COOKIE));
    } catch (e) {
        return "";
    }
}

export function persistWhitelabelKey(key) {
    const safeKey = sanitizeKey(key);

    if (!safeKey) return;

    try {
        document.cookie = `${WHITELABEL_KEY_COOKIE}=${encodeURIComponent(
            safeKey
        )}; path=/; max-age=${COOKIE_MAX_AGE}; samesite=lax`;
    } catch (e) {
        return;
    }
}
